import {React, useEffect, useState} from 'react'
import axios from 'axios'
import '../App.css';
import LoadingControl from './Loading';
import SearchTable from './SearchTable'

const MostActiveObjectsTable = (props) => {

    const layout = {
        bordered : true,
        showSizeChanger : true, 
        pagination : {pageSize: 10, showSizeChanger: false},
        size: "small",
        rowKey : record => record.id,
    };

    function calcWokload(data) {
        if (!(data instanceof Array)) {
            return [];
        } 
        
        let totalPages = 0;
        let filter_data = data.filter(rec => rec.documents > 0).map(rec => {
            totalPages += rec.pages;
            return rec;
            }
        );

        return filter_data.map(rec =>  {
            rec.workload = (rec.pages / totalPages) * 100;
            return rec;
        });
    }
    
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        data: null,
     });

     async function getData() {       
        const res = await axios(props.api_url);
        return res.data;
        }

    function update() {
        setState({...state, isLoaded: false});
    
        getData()
        .then(res => {
            setState({...state,  error: null, isLoaded: true, data: calcWokload(res)});
        })
        .catch(err => {
            console.log(err);
            setState({...state, error: err, isLoaded: false, data: null});
        });
        }  

    useEffect(() => {
        update();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    if(state.error != null)
    {
        return (
            <div>
                <h3>{state.error.message}</h3>
            </div>
        );
    }
    else if (!state.isLoaded)
    {
        return (
            <div><LoadingControl/></div>
        );
    }
    else
    {      
        return (       
            <div className = "report-table">
                <SearchTable
                    layout = {layout}
                    type = {undefined}
                    columns={props.get_columns} 
                    dataSource={state.data} 
                />
            </div>
            );
    }
}

export default MostActiveObjectsTable;